// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__NPuR9","formBtnSubmit":"LoginForm_formBtnSubmit__jGHrE","errorMsg":"LoginForm_errorMsg__0Tv7t","contactEmail":"LoginForm_contactEmail__ls9IO"};